import { render, staticRenderFns } from "./DatabaseTypeCard.vue?vue&type=template&id=5ed62422&scoped=true&"
import script from "./DatabaseTypeCard.vue?vue&type=script&lang=js&"
export * from "./DatabaseTypeCard.vue?vue&type=script&lang=js&"
import style0 from "./DatabaseTypeCard.vue?vue&type=style&index=0&id=5ed62422&lang=scss&scoped=true&"
import style1 from "./DatabaseTypeCard.vue?vue&type=style&index=1&id=5ed62422&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed62422",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ed62422')) {
      api.createRecord('5ed62422', component.options)
    } else {
      api.reload('5ed62422', component.options)
    }
    module.hot.accept("./DatabaseTypeCard.vue?vue&type=template&id=5ed62422&scoped=true&", function () {
      api.rerender('5ed62422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/launchService/DatabaseTypeCard.vue"
export default component.exports